export const labelTokens = {
  overline:
    'text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400',
  overlineMuted:
    'text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400',
  hairline: 'h-px bg-gray-100 dark:bg-gray-800',
};
